import React from "react"
import { Skeleton, Card, Space, Tabs } from "antd"

const { TabPane } = Tabs

const DetailsSkeleton = () => (
  <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
    <div style={{ padding: '16px 24px', borderBottom: '1px solid #f0f0f0' }}>
      <Space style={{ width: '100%', justifyContent: 'space-between' }}>
        <Space>
          <Skeleton.Button active size="small" />
          <Skeleton.Button active size="small" />
          <Skeleton.Button active style={{ width: 80, borderRadius: '12px' }} />
        </Space>
        <Space>
          <Skeleton.Button active size="small" />
          <Skeleton.Button active size="small" />
          <Skeleton.Button active size="small" />
        </Space>
      </Space>
    </div>

    <div style={{ padding: '24px', flex: 1, overflow: 'auto' }}>
      <Tabs activeKey="profile">
        <TabPane tab="Profile" key="profile">
          <Card style={{ marginBottom: 16 }}>
            <Skeleton active avatar paragraph={{ rows: 4 }} />
          </Card>
          <Card style={{ marginBottom: 16 }}>
            <Skeleton active paragraph={{ rows: 3 }} />
          </Card>
          <Card>
            <Skeleton active paragraph={{ rows: 2 }} />
          </Card>
        </TabPane>
      </Tabs>
    </div>
  </div>
)

export default DetailsSkeleton
